import { render, staticRenderFns } from "./ExameEspecialidade.vue?vue&type=template&id=41558f5f&scoped=true"
import script from "./ExameEspecialidade.vue?vue&type=script&lang=js"
export * from "./ExameEspecialidade.vue?vue&type=script&lang=js"
import style0 from "./ExameEspecialidade.vue?vue&type=style&index=0&id=41558f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41558f5f",
  null
  
)

export default component.exports